import React from "react";
import {constants} from "@/constants.js";
import {urlChatID} from "@/utils/url.js";

import {
    useQueryClient,
    useQuery,
} from 'react-query';
import Icon from "@/components/ui/Icon.jsx";
import {EventBus} from "@/store/event-bus.ts";
import {queryKeyChatbotSummary} from "@/pages/chatbot/sources/ChatBotSources";
import DocStatusBadge from "@/components/DocStatusBadge.jsx";
import {queryKey} from "@/store/queryKeys.ts";
import {useTranslation} from "react-i18next";

const ListTexts = () => {
    const queryClient = useQueryClient();
    const {t} = useTranslation();

    let {isLoading, isError, data} = useQuery(queryKey.chatbotSourcesTexts(), async function() {
        let res = await fetch(`${constants.url.API_PREFIX}chatbot/${urlChatID()}/texts`)
        return res.json()
    });
    const invalidateCache = () => {
        queryClient.invalidateQueries(queryKey.chatbotSourcesTexts())
        queryClient.invalidateQueries(queryKeyChatbotSummary)
    }

    const [uploadHandler, setUploadHandler] = React.useState(false)

    if (!uploadHandler) {
        setUploadHandler(true)
        let bus = EventBus.getInstance().registerSingle('chatbot.sources.texts.add', () =>{
            invalidateCache()
        })
    }
    const apiDocumentDelete = (id) => {
        return fetch(`${constants.url.API_PREFIX}chatbot/${urlChatID()}/document/${id}/delete`)
            .then(invalidateCache)
    }

    if (isLoading) return <p>Loading...</p>;
    if (isError || !data) return <p>Error: Can't load files</p>;

    let charactersTotal = 0;
    return (
        <div className="mt-4">
            <div className="py-1 font-bold flex justify-between">
                <div className="w-3/4 flex items-center">
                    {t("knowledge_base.texts")} {data.texts.length ? `(${data.texts.length})` : ``}
                </div>
                <div className="flex justify-center w-20">
                    {t("knowledge_base.characters")}
                </div>
                <div className="flex justify-center w-20">
                    {t("knowledge_base.actions")}
                </div>
            </div>
            {data.texts.map((item, i) => {
                charactersTotal += item.characters !== -1 ? item.characters : 0;
                return (
                    <div key={i} className="py-3 border-b hover:bg-slate-200 flex justify-between">
                        <div className="w-3/4 flex">
                            <div className="w-20 flex items-center">
                                <DocStatusBadge status={item.status} />
                            </div>
                            <div>
                                {item.title ? item.title : 'Untitled'}
                                <div className="text-slate-400">
                                    {item.text}
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-center items-center w-20">
                            {item.characters !== -1 ? item.characters : ''}
                        </div>
                        <div className="flex justify-center items-center w-20">
                            <div className="cursor-pointer"
                                 title={"Delete text"}
                                 onClick={(e) => apiDocumentDelete(item.id)}
                            >
                                <Icon icon="heroicons:archive-box-x-mark" className="w-6 h-6 text-gray-400 hover:text-red-600"/>
                            </div>
                        </div>
                    </div>
                );
            })}
            {!!data.texts.length &&
                <div className="py-1 font-bold flex justify-between">
                    <div className="w-3/4 flex items-center">
                    </div>
                    <div className="flex justify-center w-20">
                        {charactersTotal ? charactersTotal : ''}
                    </div>
                    <div className="flex justify-center w-20">
                    </div>
                </div>
            }
        </div>
    )
}

export default ListTexts